// BM-H4126 (Vanessa, 9 Oct 2026): the invoice line for time from a note is a
// standard line by kind of note and person, never the note's content.
// Mirrors backend/hub/attendance_narrative.py, which is what the server
// actually saves; this copy only shows the same line on screen. Keep the two
// in step (both carry the same table in their tests).
const TYPE_HEADS = {
  email: "Email attendance",
  letter: "Letter attendance",
  document: "Document review",
  research: "Research",
  other: "Attendance",
};

export function attendanceTimeNarrative(attendanceType = "telephone", channel = "telephone", party = "") {
  const t = String(attendanceType || "telephone").trim().toLowerCase();
  const c = String(channel || "telephone").trim().toLowerCase();
  const who = String(party || "").split(/\s+/).filter(Boolean).join(" ");
  let head;
  if ((t === "telephone" || t === "meeting") && (c === "teams" || c === "zoom")) head = "Virtual meeting attendance";
  else if (t === "meeting" || (t === "telephone" && c === "in_person")) head = "Meeting attendance";
  else if (t === "telephone") head = "Telephone attendance";
  else if (t === "file_note") head = "File note";
  else head = TYPE_HEADS[t] || "Attendance";
  if (!who || head === "Document review" || head === "Research") return head;
  return `${head} on ${who}`;
}
